export const NOTE_SUMMARY_STATUS = {
  inProgress: 'in_progress',
  generated: 'generated',
  skipped: 'skipped',
  failed: 'failed',
}

export const RENDERED_NOTE_SUMMARY_STATUSES = new Set([
  NOTE_SUMMARY_STATUS.generated,
  NOTE_SUMMARY_STATUS.inProgress,
])

export const NOTE_PREVIEW_CARD_EVENT = {
  edit: 'Note preview card - Edit Click',
  clone: 'Note preview card - Clone Click',
  remove: 'Note preview card - Delete Click',
  manage_summaries: 'Note preview card - Manage Summaries Click',
}

export const NOTE_PREVIEW_CARD_PLACEMENT = {
  notesTab: 'notes_tab',
  recentNote: 'recent_note',
}

export const ENTITY_ROUTE_BY_TYPE = {
  meeting: 'app.appointment.show',
  appointment: 'app.appointment.show',
  payment: 'app.payment.show',
}
